module.exports = __webpack_public_path__ + "img/up_arrow.fce8f637.png";